module.exports = __webpack_public_path__ + "static/media/5.26bddeaa.jpg";